import {request} from './../request.js'
import AppConfig from '../../../config/AppConfig.js'

// 根据长链接，生成短链接
export function webGetOrderUrl(fansId,callback){
	let param = {
		fansId: fansId
	}
	request({
			method: 'post',
			url: 'other/getOrderUrl',
			data: param
	}).then((response)=>{
		callback(response.data)
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}

/**
 * 获取第三方订单接口
 * @param {Object} param
 * @param {Object} callback
 */
export function getThirdOrderList(param,callback){
	request({
		method: 'post',
		url: 'other/getOrderList',
		data: param
	}).then((response)=>{
		callback(response.data)
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}

// 保存红包数据
export function webSaveRedPacket(param,callback){
	request({
			method: 'post',
			url: 'other/saveRedPacket',
			data: param
	}).then((response)=>{
		callback(response.data)
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}

// 获取红包列表
export function webGetRedPacketList(fansId,callback){
	request({
		method: 'post',
		url: 'other/getRedPacketList',
		data: {
			fansId: fansId
		}
	}).then((response)=>{
		callback(response.data)
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}

// 作废红包
export function webDelRedPacket(rpu_id,callback){
	request({
			method: 'post',
			url: 'other/delRedPacket',
			data: {
				rpu_id: rpu_id
			}
	}).then((response)=>{
		callback(response.data)
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}
